<template>
  <div class="w-full">
    <b-modal
      v-model="modalVerErro"
      :title="titulo"
      centered
      size="lg"
      hide-footer
      @hidden="closeModal"
    >
      <div class="w-full vs-con-loading__container" id="erroConsulta">
        <VuePerfectScrollbar class="scroll-erros m-0 p-0" :settings="confScroll">
          <div v-for="(data, index) in erro" :key="index" style="padding: 10px; border-bottom: 1px solid #eee; margin-bottom: 10px;">
            <vs-row>
              <vs-col vs-w="12" style="margin-bottom: 5px;">
                <!-- Solicitado: Erro todo em vermelho -->
                <span style="color: red; font-weight: bold; font-size: 14px;">
                  Erro: {{ data.Codigo }}
                </span>
              </vs-col>
              <vs-col vs-w="12">
                <span style="font-weight: 600; font-size: 12px;">Descrição:</span>
                <span style="font-size: 12px; margin-left: 5px;">{{ data.Descricao }}</span>
                <span v-if="data.Complemento" style="font-size: 12px; margin-left: 5px; color: #666;">
                  - {{ data.Complemento }}
                </span>
              </vs-col>
            </vs-row>
          </div>
          <div style="margin-top: 20px; text-align: right; padding: 10px;">
             <vs-button color="danger" type="flat" @click="modalVerErro = false">Fechar</vs-button>
          </div>
        </VuePerfectScrollbar>
      </div>
    </b-modal>
  </div>
</template>
<script>
import components from "@/components/default/exports.js"
export default {
  props: {
    titulo: { default: "Ver Erros" },
    nota: {},
    json: null,
  },
  data () {
    return {
      modalVerErro: false,
      erro: [],
      confScroll: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
    }
  },
  methods: {
    async openModal () {
      this.modalVerErro = true
      
      let dataJson = this.json;
      if (typeof dataJson === 'string') {
          try {
              dataJson = JSON.parse(dataJson);
          } catch(e) {
              console.error("Erro parse JSON verErros", e);
          }
      }

      this.erro = [];

      if (dataJson) {
        // PRIORIDADE 1: Erros do Fiscal Core (Novo Padrão)
        // O backend retorna 'erros' no serverStatus. Isso é o mais detalhado e correto.
        if (dataJson.erros && Array.isArray(dataJson.erros) && dataJson.erros.length > 0) {
           this.erro = dataJson.erros.map(e => ({
               Codigo: e.Codigo,
               Descricao: e.Descricao,
               Complemento: e.Complemento
           }));
           return;
        }

        // PRIORIDADE 2: ListaMensagemRetorno (Legado / Adapter Backend)
        // Se não tiver 'erros', tentamos pegar do formato antigo ou adaptado
        if (dataJson.ListaMensagemRetorno) {
          let lista = dataJson.ListaMensagemRetorno.MensagemRetorno;
          if (!Array.isArray(lista)) lista = [lista];
          
          this.erro = lista.map(e => {
            // Tenta extrair código da mensagem se não existir propriedade Codigo (ex: "RNG6110 - Descricao")
            let cod = e.Codigo;
            let msg = e.Mensagem;
            
            // Lógica simples para separar se estiver junto na Mensagem (caso legado)
            if (!cod && msg && msg.indexOf(' - ') > 3) {
                // Heurística básica: Poderíamos tentar splitar, mas melhor deixar como está se não temos certeza
                // cod = msg.split(' - ')[0];
            }

            return {
                Codigo: cod || 'Erro',
                Descricao: msg,
                Complemento: e.Correcao // Mapeia Correção antiga para "complemento" se existir
            }
          });
          return;
        }
        
        // Texto puro (ex.: resposta legada do fiscal-core): mostra como veio, sem aspas de JSON.stringify
        if (typeof dataJson === 'string') {
          this.erro.push({ Codigo: 'Erro', Descricao: dataJson, Complemento: '' });
          return;
        }

        // ULTIMO CASO: Objeto direto sem estrutura conhecida
        this.erro.push({
            Codigo: dataJson.codigo || dataJson.status || 'Erro',
            Descricao: dataJson.mensagem || dataJson.message || JSON.stringify(dataJson),
            Complemento: ''
        });

      } else {
        // Se não veio JSON no props, tenta buscar via API (Legado total)
        await this.getErrosConsulta()
      }
    },
    async getErrosConsulta () {
      await this.$vs.loading({
        container: "#erroConsulta",
        scale: 0.6,
      })
      try {
        let res = await this.$http.get(`getErroConsulta/${this.nota.rps}`)
        // Adapter para o formato do novo array 'erro'
        if (Array.isArray(res)) {
            this.erro = res.map(e => ({
                Codigo: e.Codigo,
                Descricao: e.Mensagem,
                Complemento: e.Correcao
            }))
        } else {
             this.erro = [{
                Codigo: res.Codigo || 'Erro',
                Descricao: res.Mensagem || JSON.stringify(res),
                Complemento: res.Correcao
             }]
        }

      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        await this.$vs.loading.close("#erroConsulta > .con-vs-loading")
      }
    },
    async closeModal () {
      this.modalVerErro = false
    },
  },
  async mounted () {
    await this.openModal()
  },
  components: {
    ...components,
  },
};
</script>
<style scoped>
.scroll-erros {
  height: 52vh !important;
}
</style>
